var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinFB3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4814_149146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41406 5.22083V2.74167H8.91406C9.18906 2.74167 9.41406 2.51854 9.41406 2.24583C9.41406 1.97312 9.18906 1.75 8.91406 1.75H3.91406C3.63906 1.75 3.41406 1.97312 3.41406 2.24583C3.41406 2.51854 3.63906 2.74167 3.91406 2.74167H4.41406V5.22083C4.41406 6.04392 3.74406 6.70833 2.91406 6.70833V7.7H5.89906V11.1708L6.39906 11.6667L6.89906 11.1708V7.7H9.91406V6.70833C9.08406 6.70833 8.41406 6.04392 8.41406 5.22083Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6412 7.5835V12.9748H9.39339V8.99056L8.16406 9.34973V8.40181L10.5264 7.5835H10.6412Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4814_149146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFB3);
export default __webpack_public_path__ + "static/media/pin_f_b3.e524fbe99dca49fcb9a33849fab6fbb2.svg";
export { ForwardRef as ReactComponent };